(() => {
  angular
    .module('app')
    .controller('clinic.views.hospital.topUpRequest', TopUpRequestPageController);

  TopUpRequestPageController.$inject = [
    '$scope',
    '$stateParams',
    '$state',
    'abp.services.app.hospitalPanelServiceRequest',
    'abp.services.app.commonLookup',
  ];

  function TopUpRequestPageController(
    $scope,
    $stateParams,
    $state,
    hospitalPanelServiceRequestSvc,
    commonLookupSvc
  ) {
    const vm = this;
    vm.loading = 0;
    vm.saving = 0;
    vm.letterNumber = $stateParams.letterNumber;
    vm.panelLocationId = $stateParams.panelLocationId;
    vm.requestId = $stateParams.requestId;
    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.hasInpatientRegionalExpansion = abp.setting.getBoolean(
      'Hms.Feature.RegionalExpansionForInpatient'
    );

    vm.requestParams = { requestType: $stateParams.requestType };

    vm.activeTab = 0;
    vm.topUpRequest = {
      interimBillAmount: null,
      selectedDoctorIds: [],
      newAttachments: [],
    };
    vm.uploadConfig = { objectType: 'InpatientTopupAddonRequestAttachment' };
    vm.checklistItems = [
      { text: App.localize('CompletedTopUpAddOnRequestForm'), required: true },
      {
        text: App.localize('InterimBillSummaryBreakdown'),
        required: vm.requestParams.requestType === 1 || vm.requestParams.requestType === 2,
      },
      { text: App.localize('AllInvestigationReport'), required: true },
      {
        text: App.localize('AdditionalAttendingPhysicianStatement'),
        required: vm.requestParams.requestType === 1 || vm.requestParams.requestType === 3,
      },
    ];

    vm.nextTab = nextTab;
    vm.previousTab = previousTab;
    vm.save = save;
    vm.setActiveTab = setActiveTab;
    vm.downloadTopUpAddOnRequestForm = downloadTopUpAddOnRequestForm;
    vm.downloadAttendingPhysicianStatement = downloadAttendingPhysicianStatement;

    function init() {
      getDoctors();
      if (vm.hasInpatientRegionalExpansion) {
        getLanguage();
        getCurrency();
      }
    }

    /* Functions */

    function getDoctors() {
      vm.loading += 1;
      hospitalPanelServiceRequestSvc
        .getDoctorsNotInGL({
          letterNumber: vm.letterNumber,
        })
        .success((data) => {
          vm.specialistDoctors = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getLanguage() {
      vm.loading += 1;
      commonLookupSvc
        .getDefaultLanguageByCountryCode()
        .success((data) => {
          vm.language = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getCurrency() {
      vm.loading += 1;
      commonLookupSvc
        .getTenantCurrencyCode()
        .success((data) => {
          vm.currencyCode = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function nextTab() {
      if (vm.activeTab === 2) {
        return;
      }
      if (vm.activeTab === 0 && !App.isFormValid($scope.forms.topUp)) {
        return;
      }
      if (vm.activeTab === 1) {
        vm.invalidAttachment = vm.topUpRequest.newAttachments.length < 1;
        vm.invalidChecklist =
          !App.isFormValid($scope.forms.uploadDocuments) &&
          _.some(vm.checklistItems, (d) => d.required && !d.isChecked);
        if (vm.invalidAttachment || vm.invalidChecklist) {
          return;
        }
      }
      setActiveTab(vm.activeTab + 1);
    }

    function previousTab() {
      setActiveTab(vm.activeTab - 1);
    }

    function save() {
      vm.saving += 1;

      const checklistItems = [];
      _.each(vm.checklistItems, (item) => {
        checklistItems.push({
          text: item.text,
          isSelected: item.isChecked,
          isMandatory: item.required,
        });
      });

      const input = $.extend(vm.topUpRequest, {
        letterNumber: vm.letterNumber,
        documentChecklistItems: checklistItems,
        doctorIds: vm.topUpRequest.selectedDoctorIds,
      });

      hospitalPanelServiceRequestSvc
        .requestTopupAddon(input)
        .success(() => {
          abp.notify.success(App.localize('Submitted'));
        })
        .finally(() => {
          vm.saving -= 1;
          $state.go('clinic.inpatientDashboard');
        });
    }

    function setActiveTab(tab) {
      if (tab < 0 || tab > 2) return; // Prevent tab out of range.
      vm.activeTab = tab;
    }

    function downloadTopUpAddOnRequestForm(language) {
      vm.exporting += 1;
      // Pass in prefilled data
      hospitalPanelServiceRequestSvc
        .getTopUpAddOnRequestFormPdf({
          guaranteeLetterNumber: vm.letterNumber,
          language,
        })
        .success((data) => {
          App.downloadTempFile(data);
        })
        .finally(() => {
          vm.exporting -= 1;
        });
    }

    function downloadAttendingPhysicianStatement() {
      vm.exporting += 1;
      // Pass in prefilled data
      hospitalPanelServiceRequestSvc
        .getAttendingPhysicianStatementPdf({ id: vm.letterNumber })
        .success((data) => {
          App.downloadTempFile(data);
        })
        .finally(() => {
          vm.exporting -= 1;
        });
    }

    /* End of Functions */

    init();
  }
})();
